import type { BatchEditFormErrorProps } from "./batch-edit-form-error.type";

import { Alert, Typography } from "antd";
import { useTranslation } from "react-i18next";

import "./batch-edit-form-error.style.less";

const { Paragraph } = Typography;

const BatchEditFormError = ({
  modelKey,
  customMessages,
}: BatchEditFormErrorProps) => {
  const { t } = useTranslation();

  const messages = customMessages ?? [
    t(`${modelKey}:batchEdit.formError.default`),
    t(`${modelKey}:batchEdit.formError.noItemUpdated`),
  ];

  return (
    <Alert
      type="error"
      title={messages.map((message) => (
        <Paragraph key={message}>{message}</Paragraph>
      ))}
      showIcon
      className="batch-edit-form-error"
    />
  );
};

export default BatchEditFormError;
